export const getStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export const setlocalStorage = (key, value) => {
  return localStorage.setItem(key, value);
};

export const getTag = (status, t) => {
  switch (status) {
    case "success":
      return {
        // icon: <CheckCircleOutlined />,
        name: `${t("txt_succeedV2")}`,
        color: "#28a745",
      };
    case "process":
      return {
        // icon: <SyncOutlined spin />,
        name: `${t("txt_process")}`,
        color: "#ffc107",
      };
    case "failed":
      return {
        // icon: <ExclamationCircleOutlined />,
        name: `${t("txt_isnot_success")}`,
        color: "#dc3545",
      };
    case "withdraw_failed":
      return { name: `${t("txt_isnot_success")}`, color: "magenta" };
    case "withdraw_cancel":
      return { name: `${t("txt_cancel")}`, color: "#dc3545" };
    case "withdraw_success":
      return { name: `${t("txt_succeedV2")}`, color: "#28a745" };
    case "withdraw_waiting":
      return { name: `${t("txt_wait_process")}`, color: "gold" };
    default:
      return { name: "-", color: "" };
  }
};

export const getTagLotto = (status, t) => {
  switch (status) {
    case "success":
      return {
        name: `${t("txt_the_prize_has_been_issued")}`,
        color: "#0d6efd",
      };
    case "cancel":
      return { name: `${t("txt_cancel")}`, color: "#ff4d3b" };
    case "pending":
      return {
        name: `${t("txt_waiting_for_the_prize_drawn")}`,
        color: "#ffc107",
      };
    case "won":
      return {
        name: `${t("txt_won_a_prize")}`,
        color: "#28a745",
      };
    case "lost":
      return {
        name: `${t("txt_didn_win_the_prize")}`,
        color: "#dc3545",
      };
    case "active":
      return {
        name: `${t("txt_waiting_for_the_prize_drawn")}`,
        color: "#ffc107",
      };
    case "settled":
      return {
        name: `${t("txt_the_prize_has_been_issued")}`,
        color: "#ffc107",
      };
    case "cancelled":
      return { name: `${t("txt_cancel")}`, color: "#ff4d3b" };
    default:
      return { name: "-", color: "" };
  }
};
